export default __webpack_public_path__ + "static/media/Bpin.6819ec51.jpg";